import React from "react";
import { DragDropContext, Droppable,  } from "react-beautiful-dnd";
import "./Supersets.scss";
import Superset from "../Superset";

export default function Supersets({supersetName, previousValues, isPersonal, supersets, setName, isAdmin,  error, exercises, setSupersets, removeExercise, removeSet, onDragEnd, onClickSearch, onChange}) {

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="sets" type="parent">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {supersets.map((item, idx) => (
              <Superset previousValues={previousValues} supersets={supersets} setSupersets={setSupersets} setName={setName} isPersonal={isPersonal} isAdmin={isAdmin} exercises={exercises} error={error} set={item} set_idx={idx} removeSet={(e) => removeSet(e)} removeExercise={removeExercise} onClickSearch={onClickSearch} onChange={(e, type, exidx, setidx, subIdx, subex) => {onChange(e, type, exidx, idx, subIdx, subex)}}/>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
